import type { ProductProjection } from "@commercetools/platform-sdk";
import { isError } from "@sindresorhus/is";
import { useContext, useEffect, useState } from "react";
import { AppDispatchContext, useAppState } from "../context/app/context";
import { fetchGiftBox } from "../utils/commercetools/product-service";

type UseProductGiftBox = () => {
	giftBoxProduct: ProductProjection | undefined;
	error: boolean;
};

export const useProductGiftBox: UseProductGiftBox = () => {
	const [error, setError] = useState<boolean>(false);
	const { giftBoxProduct } = useAppState();
	const appDispatch = useContext(AppDispatchContext);
	if (!appDispatch) throw new Error("Dispatch undefined, should not happen.");

	useEffect(() => {
		const fetchProduct = async () => {
			try {
				const giftBoxProduct = await fetchGiftBox();

				if (giftBoxProduct) {
					appDispatch({
						type: "setGiftBoxProduct",
						product: giftBoxProduct,
					});
				}
			} catch (error) {
				setError(true);
				console.error(isError(error) ? error.message : error);
			}
		};

		if (!giftBoxProduct) {
			void fetchProduct();
		}
	}, [appDispatch, giftBoxProduct]);

	return {
		giftBoxProduct,
		error,
	};
};
